export enum CustomerProjectType {
    maintenance = 'maintenance',
    regular = 'regular',
    drillings = 'drillings',
}
